import {
  ActionFunctionArgs,
  LoaderFunctionArgs,
  redirect,
} from 'react-router-dom'
import { z } from 'zod'

import { contactSchema } from '@/schema.ts'

interface ActionData {
  errors?: z.ZodIssue[]
  error?: string
}

const action = async ({
  request,
}: ActionFunctionArgs): Promise<ActionData | Response> => {
  const formData = await request.formData()
  const contactData = {
    email: formData.get('email'),
    phone: formData.get('telephone'),
  }
  const result = contactSchema.safeParse(contactData)

  if (!result.success) {
    return { errors: result.error.issues }
  }

  return redirect('/referral/proposed-appointment')
}

const loader = (_arg: LoaderFunctionArgs) => {
  return null
}

export type { ActionData }
export { action, loader }
